import { SelectType } from '../dropdown/type';

const SEARCH_TYPE: SelectType<string>[] = [
  { name: 'Keyword', value: 'keyword' },
  { name: 'Channel', value: 'channel' },
];

export default SEARCH_TYPE;
